export default RAILS_ASSET_URL("/gallery-image-04.webp")
